export interface SceneElementActionConfigurationSpecification {
    sceneElementId: string;
    browserAndPhysicsLoadableId: string;
    controllerConfigurations: ControllerConfiguration[];
    actionSpaceConfiguration: ActionSpaceConfiguration;
}

export interface SceneElementActionConfigurationUpdateDTO {
    sceneElementId: string;
    browserAndPhysicsLoadableId: string;
    controllerConfigurations: BaseControllerConfiguration[];
    actionSpaceConfiguration: string;
}

export interface BaseControllerConfiguration {
    name: string;
    value: any;
}

export interface ControllerConfiguration extends BaseControllerConfiguration {
    type: ControllerConfigurationValueTypes;
    validationRules: ValidatorTypes[];
}

export interface ActionSpaceConfiguration {
    actionConfig: string;
    availableConfigs: string[];
}

export enum ControllerConfigurationValueTypes {
    DOUBLE = 'DOUBLE',
    INTEGER = 'INTEGER',
    STRING = 'STRING',
}

export enum ValidatorTypes {
    REQUIRED = 'REQUIRED',
    VALIDATE_POSITIVE_DOUBLE = 'VALIDATE_POSITIVE_DOUBLE',
}
